import { createFileRoute } from "@tanstack/react-router";
import Impact from "@/features/onboarding/pages/impact/Impact";

export const Route = createFileRoute("/$locale/$partner/_onboarding/impact")({
	component: Impact,
});
